import React, { useState } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { CollapsibleSection } from './CollapsibleSection';
import { FormField } from './FormField';
interface IntroScreen {
  id: string;
  title: string;
  content: string;
  assetId: string;
  showBannerImage?: boolean;
}
export function CourseIntroductionTab() {
  const [isEnabled, setIsEnabled] = useState(true);
  const [screens, setScreens] = useState<IntroScreen[]>([{
    id: '1',
    title: '',
    content: '',
    assetId: '',
    showBannerImage: false
  }, {
    id: '2',
    title: '',
    content: '',
    assetId: ''
  }]);
  const addScreen = () => {
    setScreens([...screens, {
      id: Date.now().toString(),
      title: '',
      content: '',
      assetId: ''
    }]);
  };
  const removeScreen = (id: string) => {
    setScreens(screens.filter(s => s.id !== id));
  };
  const updateScreen = (id: string, field: keyof IntroScreen, value: string | boolean) => {
    setScreens(screens.map(s => s.id === id ? {
      ...s,
      [field]: value
    } : s));
  };
  return <div className="space-y-6 animate-in fade-in duration-300" data-id="element-32">
      <CollapsibleSection title="Introduction Configuration" data-id="element-33">
        <div className="space-y-8" data-id="element-34">
          {/* Enable Checkbox */}
          <div className="flex items-start gap-3" data-id="element-35">
            <div className="flex items-center h-5" data-id="element-36">
              <input id="enable-intro" type="checkbox" checked={isEnabled} onChange={e => setIsEnabled(e.target.checked)} className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" data-id="element-37" />
            </div>
            <div className="text-sm" data-id="element-38">
              <label htmlFor="enable-intro" className="font-medium text-gray-900" data-id="element-39">
                Enable Course Introduction
              </label>
              <p className="text-gray-500 mt-0.5" data-id="element-40">
                Enables whether the course introduction is shown to the user for
                this course
              </p>
            </div>
          </div>

          {isEnabled && <div className="space-y-8 border-t border-gray-100 pt-8" data-id="element-41">
              {screens.map((screen, index) => <div key={screen.id} className="bg-gray-50/50 rounded-lg p-6 border border-gray-100 relative group" data-id="element-42">
                  <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-43">
                    <button onClick={() => removeScreen(screen.id)} className="text-gray-400 hover:text-red-500 p-1" title="Remove screen" data-id="element-44">
                      <Trash2 className="w-4 h-4" data-id="element-45" />
                    </button>
                  </div>

                  <h4 className="text-sm font-bold text-gray-900 mb-4 uppercase tracking-wider" data-id="element-46">
                    Screen {index + 1}
                  </h4>

                  <div className="space-y-5" data-id="element-47">
                    <FormField label="Title" data-id="element-48">
                      <input type="text" value={screen.title} onChange={e => updateScreen(screen.id, 'title', e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm py-2 px-3 border" data-id="element-49" />
                    </FormField>

                    <FormField label="Content" data-id="element-50">
                      <textarea value={screen.content} onChange={e => updateScreen(screen.id, 'content', e.target.value)} rows={4} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm py-2 px-3 border min-h-[120px]" data-id="element-51" />
                    </FormField>

                    {/* Show Banner Image checkbox - only for Screen 1 */}
                    {index === 0 && <div className="flex items-start gap-3" data-id="element-52">
                        <div className="flex items-center h-5" data-id="element-53">
                          <input id="show-banner-image" type="checkbox" checked={screen.showBannerImage || false} onChange={e => updateScreen(screen.id, 'showBannerImage', e.target.checked)} className="h-4 w-4 rounded border-gray-300 text-indigo-600 focus:ring-indigo-600" data-id="element-54" />
                        </div>
                        <div className="text-sm" data-id="element-55">
                          <label htmlFor="show-banner-image" className="font-medium text-gray-900" data-id="element-56">
                            Show Banner Image
                          </label>
                          <p className="text-gray-500 mt-0.5" data-id="element-57">
                            If enabled, we will display the home page banner
                            image set onto the first screen of the instructional
                            modals
                          </p>
                        </div>
                      </div>}

                    {/* Asset ID field - only for screens after Screen 1 */}
                    {index > 0 && <FormField label="Asset ID" data-id="element-58">
                        <input type="text" value={screen.assetId} onChange={e => updateScreen(screen.id, 'assetId', e.target.value)} className="block w-full rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:text-sm py-2 px-3 border" data-id="element-59" />
                      </FormField>}
                  </div>
                </div>)}

              <button onClick={addScreen} className="flex items-center gap-2 text-sm font-medium text-indigo-600 hover:text-indigo-700 transition-colors px-2 py-1 rounded-md hover:bg-indigo-50" data-id="element-60">
                <Plus className="w-4 h-4" data-id="element-61" />
                Screen
              </button>
            </div>}
        </div>
      </CollapsibleSection>
    </div>;
}